import { render, staticRenderFns } from "./AddDocumentType.vue?vue&type=template&id=70ea4623&scoped=true"
import script from "./AddDocumentType.vue?vue&type=script&lang=js"
export * from "./AddDocumentType.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentType.vue?vue&type=style&index=0&id=70ea4623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea4623",
  null
  
)

export default component.exports